export default __webpack_public_path__ + "static/media/splashonline.4d989f19.png";